import React from "react";
import { object, string, number, func } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";

import { staticTexts } from "../../utils/Translate";
import { getExcerpt } from "../../utils/utils";

import "./numberedStoryItem.m.css";

const NumberedStoryItem = ({ story, itemNumber, clicked, className = "", lang = "" }) => {
  const excerpt = getExcerpt(story, 100);
  return (
    <div styleName="numbered-story-item" className={className} onClick={clicked}>
      <div styleName="item-number" className="item-number">
        {staticTexts(lang).NUMBER_ARRAY[itemNumber + 1]}
      </div>
      {global.deviceWidth > 875 && (
        <div styleName="item-container">
          <NewsHeadline linkEnable={false} story={story} cssStyleName="mediumBigSize" />
          {excerpt && <Excerpt linkEnable={false} excerpt={excerpt} excerptLink={story.url} />}
        </div>
      )}
    </div>
  );
};

NumberedStoryItem.propTypes = {
  className: string,
  story: object,
  itemNumber: number,
  clicked: func,
  lang: string,
};

export default NumberedStoryItem;
